module.exports = __webpack_public_path__ + "img/map1.365f4c9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/loading/imgs/map1.png
// module id = ./assets/loading/imgs/map1.png
// module chunks = 2 3 4 5 6 7 8